(() => {
  // Shopify replaces the drawer markup after an add. The newly added product
  // can become the drawer's source product, even when it has no related-item
  // configuration of its own. Keep the last usable list for that redraw.
  let lastRelatedItemsMarkup = '';

  const rememberRelatedItems = (list) => {
    if (list?.children.length) lastRelatedItemsMarkup = list.innerHTML;
  };

  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    }[character]));

  const money = (cents) => {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || window.Shopify?.currency?.shop || 'CAD'
    }).format(amount);
  };

  window.ksCartDrawerRelated = (scope = document) => {
    scope.querySelectorAll?.('[data-ks-cart-recommendations]').forEach((container) => {
      if (container.dataset.loaded === 'true') return;
      const list = container.querySelector('.ks-cart-drawer-related__list');
      if (!list) return;
      if (list.children.length) {
        rememberRelatedItems(list);
        container.dataset.loaded = 'true';
        return;
      }

      if (lastRelatedItemsMarkup) {
        list.innerHTML = lastRelatedItemsMarkup;
        container.dataset.loaded = 'true';
        return;
      }

      container.dataset.loaded = 'true';
      fetch(container.dataset.url, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : Promise.reject(response)))
        .then(async ({ products = [] }) => {
          const candidates = products.filter((product) => product.available).slice(0, 8);
          const checked = await Promise.all(candidates.map(async (product) => {
            try {
              const separator = product.url.includes('?') ? '&' : '?';
              const response = await fetch(`${product.url}${separator}section_id=ks-product-moq`, { credentials: 'same-origin' });
              const markup = await response.text();
              const page = new DOMParser().parseFromString(markup, 'text/html');
              return page.querySelector('[data-ks-product-moq]')?.dataset.discontinued === 'true' ? null : product;
            } catch (_) {
              return null;
            }
          }));
          const items = checked.filter(Boolean).slice(0, 2);
          if (!items.length) {
            // A cart refresh can return no further recommendations after the
            // shopper adds one. Keep the drawer heading visible in that state.
            return;
          }
          list.innerHTML = items.map((product) => {
            const image = product.featured_image ? `<img src="${escapeHtml(product.featured_image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : '';
            const availableVariants = (product.variants || []).filter((variant) => variant.available);
            const variantControl = availableVariants.length === 1
              ? `<input type="hidden" name="id" value="${escapeHtml(availableVariants[0].id)}">`
              : `<select class="ks-cart-drawer-related__variant" name="id" hidden aria-label="Choose ${escapeHtml(product.title)} option">${availableVariants.map((variant) => `<option value="${escapeHtml(variant.id)}">${escapeHtml(variant.title)} — ${money(variant.price)}</option>`).join('')}</select>`;
            const action = availableVariants.length === 1
              ? `<product-form class="ks-cart-drawer-related__form"><form method="post" action="/cart/add">${variantControl}<button type="submit" class="ks-cart-drawer-related__action"><span>+ Add</span><span class="loading__spinner hidden"></span></button></form></product-form>`
              : `<product-form class="ks-cart-drawer-related__form"><form method="post" action="/cart/add">${variantControl}<button type="button" class="ks-cart-drawer-related__action" data-ks-related-choose-variant><span>+ Add</span></button><button type="submit" class="ks-cart-drawer-related__action" hidden><span>+ Add</span><span class="loading__spinner hidden"></span></button></form></product-form>`;
            return `<article class="ks-cart-drawer-related__item"><a class="ks-cart-drawer-related__image" href="${escapeHtml(product.url)}">${image}</a><div class="ks-cart-drawer-related__content"><a href="${escapeHtml(product.url)}" class="ks-cart-drawer-related__title">${escapeHtml(product.title)}</a><span class="ks-cart-drawer-related__price">${money(product.price)}</span></div>${action}</article>`;
          }).join('');
          rememberRelatedItems(list);
        })
        // Keep the static Liquid heading visible if recommendations cannot load.
        .catch(() => {});
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ks-related-choose-variant]');
    if (!trigger) return;

    const form = trigger.closest('form');
    const variantControl = form?.querySelector('.ks-cart-drawer-related__variant');
    const addButton = form?.querySelector('button[type="submit"]');
    if (!form || !variantControl || !addButton) return;

    trigger.hidden = true;
    variantControl.hidden = false;
    addButton.hidden = false;
    variantControl.focus();
  });

  document.addEventListener('DOMContentLoaded', () => window.ksCartDrawerRelated());
})();
